import { View, Text } from "../../../components/Themed";
import Colors from "../../../constants/Colors";

export const QuestionAnswerView = ({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) => (
  <View style={{ paddingVertical: 12 }}>
    <Text lightColor={Colors.nuetral_grey_600}>{question}</Text>
    <Text lightColor={Colors.nuetral_grey_700}>{answer || "N/A"}</Text>
  </View>
);
